module.exports = __webpack_public_path__ + "static/media/RI-D5-0.4-041.a9cf25b9.webp";